(function () {
  const openBtn = document.querySelector("[data-open-mobile-nav]");
  const aside = document.getElementById("mobile-nav-aside");
  if (!openBtn || !aside) return;

  const closeButtons = aside.querySelectorAll("[data-close-mobile-nav]");
  const toggles = aside.querySelectorAll(".mobile-nav-link--toggle");

  function openNav() {
    aside.setAttribute("aria-hidden", "false");
    document.body.classList.add("mobile-nav-open");
  }

  function closeNav() {
    aside.setAttribute("aria-hidden", "true");
    document.body.classList.remove("mobile-nav-open");
  }

  openBtn.addEventListener("click", openNav);
  closeButtons.forEach((btn) => btn.addEventListener("click", closeNav));

  toggles.forEach((btn) => {
    btn.addEventListener("click", () => {
      const expanded = btn.getAttribute("aria-expanded") === "true";
      btn.setAttribute("aria-expanded", String(!expanded));
      const submenu = btn.nextElementSibling;
      submenu?.classList.toggle("is-open");
    });
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeNav();
  });
})();
